import { CommonModule } from '@angular/common';
import { Component, EventEmitter } from '@angular/core';
import { FormArray, FormBuilder, FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { TemporaryRedelegationService } from '../../../services/temporaryredelegation/temporary-redelegation.service';
import { Redelegation } from '../../../interface/temporaryredelegation/redelegation';
import { ActivatedRoute, Router } from '@angular/router';
import { MatTableDataSource, MatTableModule} from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ViewChild } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatPaginatorModule } from '@angular/material/paginator';
import { SharedServices } from '../../../shared/services/shared.services';

@Component({
  selector: 'app-editorcancelredelegation',
  imports: [ReactiveFormsModule, FormsModule, CommonModule, MatPaginatorModule,
         MatTableModule,
      MatProgressSpinnerModule],
  templateUrl: './editorcancelredelegation.component.html',
  styleUrl: './editorcancelredelegation.component.css'
})
export class EditorcancelredelegationComponent {
  @ViewChild(MatPaginator) paginator!: MatPaginator;
  dataSource = new MatTableDataSource<Redelegation>([]);
  @ViewChild(MatSort) sort!: MatSort;
  today: string = new Date().toISOString().split('T')[0]; // Today's date in YYYY-MM-DD format
  form!: FormGroup;
  // today:string='';
  UserEmail!: string;
  toCAI!: string;
  modalCloseEvent: EventEmitter<void> = new EventEmitter<void>();
  redelegations: Redelegation[] = [];
  redelegation!: Redelegation;
  eDate: Date = new Date();
  isDateModified:boolean=false;
  createdBy!:string;
  modifiedFields: Set<string> = new Set();
  formInitialized: boolean = false;
  isLoading: boolean = false;
  originalData: Redelegation[] = [];
  displayedColumns1: string[] = ['sno', 'toName', 'dueTo', 'startDate', 'endDate'];
  showContent: boolean = false;
  isCheckboxchecked: boolean = false;
  buttonLabel: string = 'Show Previous Delegations';
  loggedUserCAI: string='';
  constructor(private fb: FormBuilder, private tempdelegationService: TemporaryRedelegationService, private route: ActivatedRoute, private router: Router,
    private sharedServices: SharedServices
  ) {
    this.modalCloseEvent.subscribe(() => {
      this.router.navigate(['/DOA']);
    });
   }
  @ViewChild(MatPaginator) set matPaginator(mp: MatPaginator) {
    this.paginator = mp;
    this.setDataSourceAttributes();
  }
  ngOnInit() {
    this.loggedUserCAI = this.sharedServices.getloggedUserCai();
    this.form = this.fb.group({
      redelegations: this.fb.array([]),
      createdBy:[''],
      reasonForChange: ['', Validators.required] // Add this line
    });
    this.route.queryParams.subscribe(params => {
      this.UserEmail = params['userEmail'];
      this.eDate = params['eDate'];
      if (this.UserEmail) {
        this.tempdelegationService.getReDelegationHistory(this.UserEmail, this.eDate).subscribe((data: Redelegation[]) => {
          if (data) {
            this.redelegations = data;
            this.redelegation = data[0];
            this.initializeForm(data);
            this.formInitialized = true;
          }
        });
      }
    });
    this.dataSource.paginator = this.paginator;
  }
  ngAfterViewInit(): void {
    this.setDataSourceAttributes();
  }
  setDataSourceAttributes() {
    if (this.paginator) {
      this.dataSource.paginator = this.paginator;
    }
  }
  compareDates(index: number) {
    const redelegationsFormArray = this.form.get('redelegations') as FormArray;
    if (redelegationsFormArray) {
      const redelegation = redelegationsFormArray.at(index);
      if (redelegation) {
        const toEmail = redelegation.get('toEmail')?.value;
        const startDate = new Date(redelegation.get('startDate')?.value);
        const endDate = new Date(redelegation.get('endDate')?.value);
  
        // Extract only the date part
        const startDateOnly = new Date(startDate.getFullYear(), startDate.getMonth(), startDate.getDate());
        const endDateOnly = new Date(endDate.getFullYear(), endDate.getMonth(), endDate.getDate());
  
        // Compare with all other row dates
        for (let i = 0; i < redelegationsFormArray.length; i++) {
        if (i !== index) {
          const otherRedelegation = redelegationsFormArray.at(i);
          const otherStartDate = new Date(otherRedelegation.get('startDate')?.value);
          const otherEndDate = new Date(otherRedelegation.get('endDate')?.value);
  
          // Extract only the date part
          const otherStartDateOnly = new Date(otherStartDate.getFullYear(), otherStartDate.getMonth(), otherStartDate.getDate());
          const otherEndDateOnly = new Date(otherEndDate.getFullYear(), otherEndDate.getMonth(), otherEndDate.getDate());

           if ((startDateOnly >= otherStartDateOnly && startDateOnly <= otherEndDateOnly) ||
                (endDateOnly >= otherStartDateOnly && endDateOnly <= otherEndDateOnly) ||
                (startDateOnly <= otherStartDateOnly && endDateOnly >= otherEndDateOnly)) {
              this.sharedServices.openModal('Message', 'Date conflict with another row detected!');
              redelegation.get('startDate')?.setValue('');
              redelegation.get('endDate')?.setValue('');
              this.form.setErrors({ dateConflict: true });
               return;
                }
          }
        }
  
        // Fetch existing delegations and compare dates
        /* this.tempdelegationService.showDelegateeDelegations(toEmail).subscribe(existingDelegations => {
          let conflictDetected = false;
  
          for (let existing of existingDelegations) {
            const existingStartDate = new Date(existing.startDate);
            const existingEndDate = new Date(existing.endDate);
  
            // Extract only the date part
            const existingStartDateOnly = new Date(existingStartDate.getFullYear(), existingStartDate.getMonth(), existingStartDate.getDate());
            const existingEndDateOnly = new Date(existingEndDate.getFullYear(), existingEndDate.getMonth(), existingEndDate.getDate());
             let reqStatus=existing.reqStatus;
             debugger
            // Check for date conflicts
             if (
  ((startDateOnly >= existingStartDateOnly && startDateOnly <= existingEndDateOnly) ||
  (endDateOnly >= existingStartDateOnly && endDateOnly <= existingEndDateOnly) ||
  (startDateOnly <= existingStartDateOnly && endDateOnly >= existingEndDateOnly))
  && (reqStatus ==="RS"|| reqStatus==="AP"))

            {
              conflictDetected = true;
              redelegation.get('startDate')?.setValue('');
              redelegation.get('endDate')?.setValue('');
              break;
            }
          }
  
          if (conflictDetected) {
            this.sharedServices.openModal('Message', 'Date conflict detected with existing delegations!');
            this.form.setErrors({ dateConflict: true });
            return;
           }
        });
      } else {
         this.sharedServices.openModal('Message',`Redelegation at index ${index} is null or undefined`);
      }
    } else {
       this.sharedServices.openModal('Message','Redelegations form array is null or undefined');
    }
  } */

    this.tempdelegationService.showDelegateeDelegations(toEmail).subscribe(existingDelegations => 
  {
          let conflictDetected = false;
  
          for (let existing of existingDelegations) 
          {
            const existingStartDate = new Date(existing.startDate);
            const existingEndDate = new Date(existing.endDate);
  
            // Extract only the date part
            const existingStartDateOnly = new Date(existingStartDate.getFullYear(), existingStartDate.getMonth(), existingStartDate.getDate());
            const existingEndDateOnly = new Date(existingEndDate.getFullYear(), existingEndDate.getMonth(), existingEndDate.getDate());
             let reqStatus=existing.reqStatus;

             const isDateOverlapcan =    
              (startDateOnly >= existingStartDateOnly && startDateOnly <= existingEndDateOnly) ||
              (endDateOnly >= existingStartDateOnly && endDateOnly <= existingEndDateOnly) ||
              (startDateOnly <= existingStartDateOnly && endDateOnly >= existingEndDateOnly)

              if (isDateOverlapcan)
              {
                if(reqStatus ==="RS"|| reqStatus==="AP")
                  {            
                  conflictDetected = true;
                  redelegation.get('startDate')?.setValue('');
                  redelegation.get('endDate')?.setValue('');
                  break;
                  }
              }

              if (conflictDetected)
             {
                this.sharedServices.openModal('Message', 'Date conflict detected with existing delegations!');
                this.form.setErrors({ dateConflict: true });
                return;
             }
            // Check for date conflicts
          
          }  
         
  });
      } else {
         this.sharedServices.openModal('Message',`Redelegation at index ${index} is null or undefined`);
      }
    } else {
       this.sharedServices.openModal('Message','Redelegations form array is null or undefined');
    }
  }

  showDelegation() {
    this.isLoading = true;
    this.showContent = !this.showContent;
    this.buttonLabel = this.showContent ? 'Hide Previous Delegations' : 'Show Previous Delegations';
    this.tempdelegationService.showReDelegations(this.UserEmail).subscribe((data: Redelegation[]) => {
      if (data) {
        this.dataSource.data = data;
        this.setDataSourceAttributes();
        this.isLoading = false;
      }
    });
  }
  cancel() {
    history.back();
  }
  Formvalidation() {
    if (this.form.invalid) {
      this.form.markAllAsTouched(); 
      this.sharedServices.openModal('Message', 'All fields are required.');
      return false;
    }
  
    const redelegationsFormArray = this.form.get('redelegations') as FormArray;
    for (let i = 0; i < redelegationsFormArray.length; i++) {
      const redelegation = redelegationsFormArray.at(i);
      const startDate = redelegation.get('startDate')?.value;
      const endDate = redelegation.get('endDate')?.value;
  
      if (!startDate || !endDate) {
        this.sharedServices.openModal('Message', 'Start date and end date are required for all redelegations.');
        return false;
      }
    }
  
    return true;
  }
  getStartDate(index: number): string | null {
    const formArray = this.form.get('redelegations') as FormArray;
    if (formArray) {
      const control = formArray.at(index).get('startDate');
      if (control) {
        return control.value;
      }
    }
    return null;
  }
    onSubmit() {
      this.isLoading=true;
      if (!this.Formvalidation()) {
        this.isLoading=false;
        return;
      }
      interface FormValue {
        initialStartDate: string;
        initialEndDate: string;
        [key: string]: any;
      }

      const formatDate = (date: string) => {
        if (!date) return null;
        const [year, month, day] = date.split('-');
        const formattedDate = new Date(`${year}-${month}-${day}T00:00:00Z`);
        return isNaN(formattedDate.getTime()) ? null : formattedDate.toISOString();
      };

      const selectedItems = this.form.value.redelegations
        .filter((item: { delete: any; }) => item.delete)
        .map(({ statusDesc, delete: _, initialStartDate, initialEndDate, startDate, endDate, ...item }: FormValue) => ({
          ...item,
          id: item['id'],
          startDate: initialStartDate,
          endDate: initialEndDate,
          reasonForChange: this.form.value.reasonForChange,
          enteredDate:this.redelegation.enteredDate,
          fromName: this.redelegation.fromName,
          lastEditedByCAI:this.loggedUserCAI,
          dueTo:this.redelegation.dueTo,
          jobLocation:this.redelegation.jobLocation,
          FromJobtitle:this.redelegation.fromJobtitle,
          approvername:this.redelegation.approverEmail,
        }));

      const updatedItems = this.form.value.redelegations
        .filter((item: { startDate: any; initialStartDate: any; endDate: any; initialEndDate: any; }) => item.startDate !== item.initialStartDate || item.endDate !== item.initialEndDate) // Check if startDate or endDate are updated
        .map(({ delete: _, statusDesc, initialStartDate, initialEndDate, startDate, endDate, enteredDate, approvedDate, ...item }: FormValue) => ({
          ...item,
          id: item['id'],
          startDate: formatDate(startDate),
          endDate: formatDate(endDate),
          fromName: this.redelegation.fromName,
          enteredDate:this.redelegation.enteredDate,
          lastEditedByCAI:this.loggedUserCAI,
          dueTo:this.redelegation.dueTo,
          jobLocation:this.redelegation.jobLocation,
          FromJobtitle:this.redelegation.fromJobtitle,
          approvername:this.redelegation.approverEmail,
          reasonForChange: this.form.value.reasonForChange
        }));

      if (selectedItems.length > 0) {
        this.tempdelegationService.deleteRedelgation(selectedItems).subscribe({
          next: (response: any) => {
            this.isLoading=false;
             this.sharedServices.openModal('Message', 'Redelegation Details cancelled successfully');
          this.modalCloseEvent.emit();
          },
          error: (error: any) => {
            this.isLoading=false;
             this.sharedServices.openModal('Message','Error deleting details');
             this.modalCloseEvent.emit();
          }
        });
      }

      if (updatedItems.length > 0) {
        // Call update API
        this.tempdelegationService.updateRedelegation(updatedItems).subscribe({
          next: (response: any) => {
            this.isLoading=false;
             this.sharedServices.openModal('Message','Redelegation details updated successfully');
             this.modalCloseEvent.emit();
          },
          error: (error: any) => {
            this.isLoading=false;
            this.sharedServices.openModal('Message','Error updating details ');
            this.modalCloseEvent.emit();
          }
        });
      }
      if(!(updatedItems.length > 0) && !(selectedItems.length > 0)) {
        this.isLoading=false;
        this.sharedServices.openModal('Message','No changes detected');
      }
    }
    initializeForm(data: Redelegation[]) {
      const redelegationsFormArray = this.form.get('redelegations') as FormArray;
      redelegationsFormArray.clear(); // Clear existing controls if any
    
      data.forEach(item => {
        const redelegationGroup = this.fb.group({
          toName: [item.toName],
          fromEmail: [item.fromEmail],
          toEmail: [item.toEmail],
          startDate: [this.formatDate(item.startDate)],
          endDate: [this.formatDate(item.endDate)],
          delete: [{ value: false, disabled: this.isDateModified }],
          id: [item.id],
          CreatedBy: [item.createdBy],
          initialStartDate: [this.formatDate(item.startDate)], 
          initialEndDate: [this.formatDate(item.endDate)],
          fromEmpno: [item.fromEmpno], 
          toEmpno: [item.toEmpno],  
          lastModifiedBy: [item.lastModifiedBy], 
          lastEditedDate: [item.lastEditedDate],
          approvedDate: [item.approvedDate],
          approverEmail: [item.approverEmail],
          paymonth: [item.paymonth],
          reqStatus: [item.reqStatus],
        });
    
        redelegationGroup.get('startDate')?.valueChanges.subscribe(() => {
          redelegationGroup.get('endDate')?.setValue('');
          this.isDateModified = true;
          redelegationGroup.get('delete')?.disable();
        });
    
        redelegationGroup.get('endDate')?.valueChanges.subscribe(() => {
          this.isDateModified = true;
          redelegationGroup.get('delete')?.disable();
        });
    
        redelegationsFormArray.push(redelegationGroup);
      });
    }

  getJobLocation(locationCode: string): string {
    if (locationCode === 'O') {
      return 'Office';
    } else if (locationCode === 'F') {
      return 'Field';
    } else {
      return 'Unknown';
    }
  }
  formatDate(date: any): string {
    if (!date) return '';
    const d = new Date(date);
    const userTimezoneOffset = d.getTimezoneOffset() * 60000;
    const adjustedDate = new Date(d.getTime() - userTimezoneOffset);
    return adjustedDate.toISOString().split('T')[0];
  }
}